export const colors = {
  successColor: '#38bb15',
  warningColor: '#feb52b',
  errorColor: '#ff2e2e',
  linkColor: '#428bca',
  blue: '#2d7cbf',
  blueLightGray: '#d4e4e9',
  lightestGray: '#f2f2f2',
  lightGray: '#eaeaea',
  mediumLightestGray: '#dcdcdc',
  mediumLightGray: '#909092',
  mediumGray: '#c0c0c0',
  mediumDarkGray: '#606060',
  darkGray: '#404040',
  teal: '#32c3b5',
  evantaBlue: '#4330ff',
  gold: '#f2b130',
}

export const fontSizes = {
  biggestHeader: '36px',
  bigHeader: '28px',
  larger: '20px',
  large: '16px',
  medium: '14px',
  small: '13px',
  smaller: '12px',
  tiny: '11px',
}

export const homepageColors = {
  goldLight: '#F9D783',
  goldPrimary: '#92451C',
  goldDark: '#F5B51D',
  greenLight: '#C7E09A',
  greenPrimary: '#416428',
  greenDark: '#A0CA51',
  mintLight: '#8EDFD8',
  mintPrimary: '#02576C',
  mintDark: '#33C7B9',
  purpleLight: '#C3ADD2',
  purplePrimary: '#513465',
  purpleDark: '#9068AD',
}
